import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../../styles/pages/Admin/AdminPage.css';

const AdminPage = () => {
  const navigate = useNavigate();
  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <>
      <Helmet>
        <title>WeiFinders Admin Dashboard</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="admin-page">
        <Card className="admin-card">
          <Card.Body>
            <h2 className="admin-title">Admin Dashboard</h2>
            <Button variant="success" className="admin-button" onClick={() => handleNavigation('/admin/feedback')}>
              Feedback
            </Button>
            <Button variant="primary" className="admin-button" onClick={() => handleNavigation('/admin/promote-user')}>
              Promote User to Admin
            </Button>
            <Button variant="warning" className="admin-button" onClick={() => handleNavigation('/admin/reports')}>
              View Reports
            </Button>
            <Button variant="danger" className="admin-button" onClick={() => handleNavigation('/admin/create-blog')}>
              Create Blog
            </Button>
            <Button variant="secondary" className="admin-button" onClick={() => handleNavigation('/admin/guide-reviews')}>
              Guide Reviews
            </Button>
            <Button variant="outline-primary" className="admin-button" onClick={() => handleNavigation('/admin/blog-origins')}>
              Blog Origins
            </Button>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default AdminPage;
